export default "__VITE_ASSET__Bh6CoQK8__"